import { Injectable } from '@angular/core';
import type { HelpArticle, HelpArticleKey } from '@shared/modules/help-desk/articles';
import { articles } from '@shared/modules/help-desk/articles';
import _default from 'chart.js/dist/plugins/plugin.tooltip';
import { IntercomService } from './intercom.service';

@Injectable({
    providedIn: 'root'
})
export class HelpDeskService {
    constructor(
        private intercom: IntercomService
    ) {
    }

    public open(article: HelpArticle | HelpArticleKey, newTab = false): void {
        if (!article) {
            return;
        }

        const definition = typeof article === 'string' ? articles[article] : article;

        if (!definition) {
            console.warn('Missing help article definition');
            return;
        }

        // Articles outside Intercom carry a full URL and can only be opened in a new tab.
        if (definition.url) {
            window.open(definition.url, '_blank');

            return;
        }

        if (definition.i) {
            this.showIntercomArticle(definition.i, newTab);

            return;
        }

        console.warn('Help article has neither an Intercom id nor a URL', definition);
    }

    public intercomUrl(article: HelpArticle | number | string): string | null {
        if (typeof article === 'number' || typeof article === 'string') {
            return `https://help.carelinelive.com/en/articles/${article}`;
        }

        return article.i ? `https://help.carelinelive.com/en/articles/${article.i}` : null;
    }

    /**
     * Where an article lives, whether that is Intercom or a full URL elsewhere.
     */
    public articleUrl(article: HelpArticle): string | null {
        return article.url ?? this.intercomUrl(article);
    }

    public showIntercomArticle(intercomId: number, newTab = false): void {
        console.log(intercomId);

        if (!newTab && this.intercom.loaded && this.intercom.showArticle(intercomId)) {
            return;
        }

        window.open(this.intercomUrl(intercomId), '_blank');
    }
}
